import React, {  useState, useEffect } from 'react'
import {  SHIPPING_POLICY_URL } from '../../constants/api'
import axios from 'axios';

const ShippingPolicyComponent = (props) => {
    const [data, setData] = useState([]);
    

    // alert(JSON.stringify(data))

    useEffect(() => {
        fetchShippingPolicy(SHIPPING_POLICY_URL)
    }, [])

    const fetchShippingPolicy = async (url) => {
        const result = await axios(
            url,
        );
        setData(data => [...data, ...result.data.results]);
        
    };


    return (
        <div>
            <main className="main">
            <div className="page-content mt-10 pt-7">
                <section className="about-section">
                    <div className="container">
                        <h1 className="title mb-lg-12 font-weight-bold" style={{fontSize: "25px"}}>Shipping Policy</h1>
                        <div className="row mb-10">
                            <div className="col-md-12">
                            
                               
                                {data.map(shipping=>(
                                    
                                <p>{Object.keys(shipping).length>0 ? <div dangerouslySetInnerHTML={{__html: shipping.shipping_policy}} /> : ''}</p>
                                ))}  
                                
                           
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- End About Section--> */}
            </div>
</main>
        </div>
    )
}

export default ShippingPolicyComponent
